import { AppDefinition } from '../../types/apps';

export const WEB_DOCUMENT_EVENTS = {
  SCROLL_TO_TOP: 'WEB_SCROLL_TO_TOP',
  SCROLL_TO_BOTTOM: 'WEB_SCROLL_TO_BOTTOM',
  SAVE_PAGE: 'WEB_SAVE_PAGE',
  TOGGLE_READER_MODE: 'WEB_TOGGLE_READER_MODE',
} as const;

export const WebDocumentAppDefinition: AppDefinition = {
  appId: 'webdocument',
  name: 'Web Document',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Globe',
    phosphorWeight: 'duotone',
    color: '#0284c7',
  },
  version: '1.0.0',
  description: 'View and save web pages and documents',
  supportedFileTypes: ['.html', '.htm', '.mht', '.mhtml'],
  events: WEB_DOCUMENT_EVENTS,
  entityTypes: ['WebDocument'],
  component: 'WebDocumentApp',
  requiresProps: false,
  requiresEntity: true
};
